// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"hq-z","breadcrumbForward":"iq-z","breadcrumbBack":"jq-z","selected":"kq-z"};